export default __webpack_public_path__ + "static/media/monster404.294d3d55.png";